export default __webpack_public_path__ + "static/media/realestate.c7d64d22.png";